import React, { useState } from 'react';
import moment from 'moment';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';

import ReportBills from './ReportBills';

const BillsOfDay = () => {

    const date = moment(new Date()).format('YYYY-MM-DD');
    const title="Reporte de dia";

    return (
        <div  className="container">
            <Title title={title} />
            <BlockHeader title={title} />    

            <ReportBills name="Facturas" params={{ date }} />

        </div>
    );
}

export default BillsOfDay;
